import { FC } from 'react';
import { Title } from '@/components';

const NotFound: FC = () => (
  <div>
    <Title>404</Title>
  </div>
);

export default NotFound;
